import ProductMultiAdd from '@modules/product-multi-add/product-multi-add.js';
/**
 * Calculates the delta between now and the launch date
 * @returns {timestamp} the delta between now and the launch date
 */
const getDelta = launchDate => {
  return Date.parse(launchDate) - Date.now();
};

/**
 * Initializes the countdown timer
 * @param {ProductAddCTA} productAddCtaElement - the productAddCtaElement custom element
 * @param {string} launchDate - the launch date
 * @returns
 */
const initCountdownTimer = productAddCtaElement => {
  const button = productAddCtaElement.button;
  const launchDate = button.dataset.launchDate;
  if (!button || !launchDate) {
    return;
  }

  let delta = getDelta(launchDate);
  if (delta > 0) {
    productAddCtaElement.disableButton();
    ProductMultiAdd.disableAll();
  } else {
    productAddCtaElement.enableButton();
    ProductMultiAdd.enableAll();
  }
};

export { initCountdownTimer, getDelta };
